<p class="upload-message">{{uploadMessage}}</p>